
import { Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { usePedidos } from "../../../../contexts/Pedidos";


export const CabecalhoPedido = (props: any) => {
    const { situacoes } = usePedidos();
    const [sit, setSit] = useState("");

    useEffect(() => {
        situacoes.forEach((opt) => {
            if (opt.cod === parseInt(props.dadosPedido.sitped)) {
                setSit(opt.nome)
            }
        })
    }, [props.dadosPedido.sitped, situacoes]);

    return (
        <>
            <div className="cabecalho-detalhe">
                <Typography className="cabecalho-detalhe-form-title">Informações do Pedido</Typography>
                <div className="cabecalho-detalhe-form-row">
                    <div className="cabecalho-detalhe-form-column" >
                        {field("Pedido:", props.dadosPedido.numped)}
                        {field("Empresa:", props.dadosPedido.codemp == "2" ? "GA" : props.dadosPedido.codemp == "4" ? "AB": props.dadosPedido.codemp)}
                        {field("Container:", props.dadosPedido.codctn)}
                        {field("Pedido de corte:", props.dadosPedido.pedcrt !== "." ? props.dadosPedido.pedcrt : "")}
                        {field("Status:", props.dadosPedido.codmot + " - " + props.dadosPedido.desmot)}
                    </div>
                    <div className="cabecalho-detalhe-form-column">
                        {field("Transação no ERP:", props.dadosPedido.tnspro)}
                        {field("Qtd Original:", parseFloat(props.dadosPedido.qtdori).toLocaleString('pt-br', { style: 'decimal' }))}
                    </div>
                    <div className="cabecalho-detalhe-form-column">
                        {field("Data Emissão:", props.dadosPedido.datemi)}
                        {field("Data Aprovação:", props.dadosPedido.datapr !== "." ? props.dadosPedido.datapr + " " + props.dadosPedido.horapr : "")}
                        {field("Previsão de Faturamento:", props.dadosPedido.datprv)}
                    </div>
                </div>
                <div className="cabecalho-detalhe-form-row">
                    <div className="cabecalho-detalhe-form-column">
                        {field("Representante:", props.dadosPedido.codrep + " - " + props.dadosPedido.nomrep)}
                        {field("Observação:", props.dadosPedido.obsped)}
                    </div>
                </div>
            </div>
            <div className="cabecalho-detalhe">
                <Typography className="cabecalho-detalhe-form-title">Informações de Pagamento</Typography>
                <div className="cabecalho-detalhe-form-row">
                    <div className="cabecalho-detalhe-form-column">
                        {field("Valor Original:", parseFloat(props.dadosPedido.vlrori).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))}
                        {field("Condição de Pagamento:", props.dadosPedido.codcpg + " - " + props.dadosPedido.descpg)}
                        {field("Forma de Pagamento:", props.dadosPedido.codfpg + " - " + props.dadosPedido.desfpg)}
                        {field("Prazo Médio:", props.dadosPedido.przmed)}
                    </div>
                </div>
            </div>
            <div className="cabecalho-detalhe">
                <Typography className="cabecalho-detalhe-form-title">Informações do Cliente</Typography>
                <div className="cabecalho-detalhe-form-row">
                    <div className="cabecalho-detalhe-form-column">
                        {field("Código:", props.dadosPedido.codcli)}
                        {field("Nome:", props.dadosPedido.nomcli)}
                    </div>
                    <div className="cabecalho-detalhe-form-column">
                        {field("Cidade:", props.dadosPedido.cidcli)}
                        {field("Estado:", props.dadosPedido.sigufs)}
                    </div>
                    <div className="cabecalho-detalhe-form-column">
                    </div>
                </div>
                <div className="cabecalho-detalhe-form-row">
                    <div className="cabecalho-detalhe-form-column">
                        {field("Endereço:", props.dadosPedido.endcli)}
                        {field("Frete:", props.dadosPedido.desfre)}
                        {field("Redespacho:", props.dadosPedido.codred !== "0" ? props.dadosPedido.codred + " - " + props.dadosPedido.nomred : "")}
                    </div>
                </div>
            </div>

        </>
    )
}

const field = (label: string, value: string) => {
    return (
        <div className="cabecalho-detalhe-item">
            <Typography className="cabecalho-detalhe-label">{label}</Typography>
            <Typography className="cabecalho-detalhe-value">{value !== undefined && value !== "." ? value : ""}</Typography>
        </div>
    )
}